import { gql } from "graphql-request"

const flow = {
    name: 'flow',
    title: 'Flow Mainnet',
    currency: 'FLOW',
    check: true,
    regexp: '([\\W]|^)(0[x][0-9a-f]{16})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        flow(network: flow) {
            address(address: {is: $address}){
                balance: balance
                balance_usd: balance(in:USD)
            }
            ins: inputs(address: {is: $address}) {
                count: count(uniq: transactions)
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyIn: inputs(address: {is: $address}) {
                count
                currency {
                    address
                    symbol
                    tokenId
                }
            }
            outs: outputs(address: {is: $address}) {
                count: count(uniq: transactions)
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyOut: outputs(address: {is: $address}) {
                count
                currency {
                    address
                    symbol
                    tokenId
                }
            }
        }
    }
    `,
    checkAddress: '0xecfad18ba9582d4f',
}
export { flow }
